const ArticleHasAnchors = [
  {
    id: 405,
    article_id: 13,
    anchor_id: 'a2',
    content: 'Crear el directori i inicialitzar el package',
  },
  {
    id: 172,
    article_id: 11,
    anchor_id: 'a2',
    content: 'Crear el directorio e inicializar el package',
  },
  {
    id: 182,
    article_id: 12,
    anchor_id: 'a2',
    content: 'Create the directory and initialize the package',
  },
  {
    id: 401,
    article_id: 21,
    anchor_id: 'a1',
    content: 'El bàsic',
  },
  {
    id: 296,
    article_id: 18,
    anchor_id: 'a0',
    content: 'El diccionari',
  },
  {
    id: 276,
    article_id: 16,
    anchor_id: 'a0',
    content: 'El diccionario',
  },
  {
    id: 299,
    article_id: 18,
    anchor_id: 'a3',
    content: 'El divertit, el hook que tradueix',
  },
  {
    id: 173,
    article_id: 11,
    anchor_id: 'a3',
    content: 'El índice',
  },
  {
    id: 68,
    article_id: 1,
    anchor_id: 'a0',
    content: 'El problema de combinar ambos en el menú',
  },
  {
    id: 69,
    article_id: 2,
    anchor_id: 'a0',
    content: 'El problema de combinar tots dos en el menú',
  },
  {
    id: 8,
    article_id: 3,
    anchor_id: 'a0',
    content: 'El problema de combinar tots dos en el menú',
  },
  {
    id: 302,
    article_id: 5,
    anchor_id: 'a0',
    content: 'El valor sticky de la propiedad position',
  },
  {
    id: 301,
    article_id: 6,
    anchor_id: 'a0',
    content: 'El valor sticky de la propietat position',
  },
  {
    id: 297,
    article_id: 18,
    anchor_id: 'a1',
    content: 'És un núvol? És un avió? No! És el context!',
  },
  {
    id: 399,
    article_id: 20,
    anchor_id: 'a2',
    content: 'Highlight code snippets',
  },
  {
    id: 170,
    article_id: 11,
    anchor_id: 'a0',
    content: 'Instalar node.js en nuestro ordenador',
  },
  {
    id: 180,
    article_id: 12,
    anchor_id: 'a0',
    content: 'Install node.js in our computer',
  },
  {
    id: 403,
    article_id: 13,
    anchor_id: 'a0',
    content: 'Instal·lar node.js al nostre ordinador',
  },
  {
    id: 409,
    article_id: 17,
    anchor_id: 'a1',
    content: "Is it a cloud? Is it a plane? No! It's the context!",
  },
  {
    id: 406,
    article_id: 13,
    anchor_id: 'a3',
    content: "L'índex",
  },
  {
    id: 404,
    article_id: 13,
    anchor_id: 'a1',
    content: "La consola, l'eina",
  },
  {
    id: 171,
    article_id: 11,
    anchor_id: 'a1',
    content: 'La consola, la herramienta',
  },
  {
    id: 407,
    article_id: 13,
    anchor_id: 'a4',
    content: 'La publicació',
  },
  {
    id: 174,
    article_id: 11,
    anchor_id: 'a4',
    content: 'La publicación',
  },
  {
    id: 395,
    article_id: 19,
    anchor_id: 'a1',
    content: 'Lo básico',
  },
  {
    id: 279,
    article_id: 16,
    anchor_id: 'a3',
    content: 'Lo divertido, el hook que traduce',
  },
  {
    id: 298,
    article_id: 18,
    anchor_id: 'a2',
    content: "Modificar i accedir a l'idioma",
  },
  {
    id: 278,
    article_id: 16,
    anchor_id: 'a2',
    content: 'Modificar y acceder al idioma',
  },
  {
    id: 410,
    article_id: 17,
    anchor_id: 'a2',
    content: 'Modify and access the language',
  },
  {
    id: 400,
    article_id: 21,
    anchor_id: 'a0',
    content: 'Pots provar a utilitzar react-prism',
  },
  {
    id: 184,
    article_id: 12,
    anchor_id: 'a4',
    content: 'Publishing',
  },
  {
    id: 394,
    article_id: 19,
    anchor_id: 'a0',
    content: 'Puedes probar a utilizar react-prism',
  },
  {
    id: 396,
    article_id: 19,
    anchor_id: 'a2',
    content: 'Resaltar los snippets de código',
  },
  {
    id: 402,
    article_id: 21,
    anchor_id: 'a2',
    content: 'Ressaltar els snippets de codi',
  },
  {
    id: 398,
    article_id: 20,
    anchor_id: 'a1',
    content: 'The basics',
  },
  {
    id: 181,
    article_id: 12,
    anchor_id: 'a1',
    content: 'The console, the tool',
  },
  {
    id: 408,
    article_id: 17,
    anchor_id: 'a0',
    content: 'The dictionary',
  },
  {
    id: 411,
    article_id: 17,
    anchor_id: 'a3',
    content: 'The hook that translates them all',
  },
  {
    id: 183,
    article_id: 12,
    anchor_id: 'a3',
    content: 'The index',
  },
  {
    id: 70,
    article_id: 4,
    anchor_id: 'a0',
    content: 'The problem of combining both on the menu',
  },
  {
    id: 303,
    article_id: 7,
    anchor_id: 'a0',
    content: 'The sticky value of the property position',
  },
  {
    id: 412,
    article_id: 17,
    anchor_id: 'a4',
    content: 'Using the hook useT() on our components',
  },
  {
    id: 300,
    article_id: 18,
    anchor_id: 'a4',
    content: 'Utilizar el hook useT() en els nostres components',
  },
  {
    id: 280,
    article_id: 16,
    anchor_id: 'a4',
    content: 'Utilizar el hook useT() en nuestros componentes',
  },
  {
    id: 397,
    article_id: 20,
    anchor_id: 'a0',
    content: 'You can try using react-prism',
  },
  {
    id: 277,
    article_id: 16,
    anchor_id: 'a1',
    content: '¿Es una nube? ¿Es un avión? ¡No! ¡Es el contexto!',
  },
]

export default ArticleHasAnchors
